const translatePaths = {
	pl: {
		'service.worker.update.message': 'Dostępna jest nowa wersja aplikacji.',
		'service.worker.update.logoutWarning': 'Po odświeżeniu zostaniesz wylogowany.',
		'service.worker.update.button': 'Odśwież',
		'service.worker.update.refreshing': 'Odświeżanie…',
		'sales.status.generated': 'Wygenerowany',
		'sales.status.settle': 'W rozliczeniu',
		'sales.status.realized': 'Rozliczony',
		'sales.status.booked': 'Zaksięgowany',
		'sales.type.domestic': 'Krajowa',
		'sales.type.union': 'Unijna',
		'sales.type.export': 'Exportowa',
		'text.companyType': 'Typ firmy',
		'text.animators': 'Animatorzy',
		'text.suppliers': 'Dostawcy',
		'placeholder.choose': 'Wybierz',
		'yup.required': 'Pole wymagane.',
		'yup.number.required': 'Wymagana poprawna liczba.',
		'yup.string.required': 'Wymagana poprawna wartość.',
		'yup.string.email': 'Email jest niepoprawny.',
		'yup.string.min': 'Min ilość znaków: ${min}',
		'yup.string.max': 'Max ilość znaków: ${max}',
		'yup.number.positive': 'Wymagana liczba dodatnia.',
		'yup.number.min': 'Min wartość: ${min}',
		'yup.number.max': 'Max wartość: ${max}',
		'yup.date.min': 'Data nie może być przeszła.',
		'yup.date.max': 'Data nie może być przyszła.',
		'yup.polandNip': 'Nip jest niepoprawny.',
		'yup.polandPhoneNumber': 'Niepoprawny numer telefonu dla tego kraju.',
		'yup.polandNrb': 'Numer konta bankowego nie spełnia wymagań NRB.',
		'yup.polandPostalCode': 'Niepoprawny format.',
		'empty.formatBankNumber': 'Brak',
		'empty.formatAddress': 'Brak',
		'empty.formatAddressCommune': 'Brak',
		'empty.street': 'ul. ',
		'empty.commune': 'Gmina:',
		'empty.district.part.1a': ', p',
		'empty.district.part.1b': 'P',
		'empty.district.part.2': 'owiat:',
		'empty.province': 'Województwo:',
		'empty.country': 'Kraj:',
		'empty.formatNip': 'Brak',
		'empty.readonly': 'Brak',
		'boolean.yes': 'Tak',
		'boolean.no': 'Nie',
		'options.notificationEmailGroups.name.1': 'Profilowe i systemowe',
		'options.notificationEmailGroups.name.2': 'Umowa animacji',
		'options.notificationEmailGroups.name.3': 'Faktury i zlec. dostawcy',
		'options.notificationEmailGroups.name.4': 'Marketing',
		'options.notificationEmailGroups.name.5': 'Pomoc',
		'options.aml.type.1': 'Base',
		'options.aml.type.2': 'Standard',
		'options.aml.type.3': 'Extra',
		'options.aml.type.4': 'Max',
		'options.notificationPersonGroups.name.1': 'Profilowe i systemowe',
		'options.notificationPersonGroups.name.2': 'Umowa animacji',
		'options.notificationPersonGroups.name.3': 'Faktury i zlec. dostawcy',
		'options.notificationPersonGroups.name.4': 'Marketing',
		'options.notificationPersonGroups.name.5': 'Pomoc',
		'options.grouping.name.1': 'bez grupowania',
		'options.grouping.name.2': 'dzień',
		'options.grouping.name.3': 'tydzień',
		'options.grouping.name.4': 'miesiąc',
		'options.grouping.name.5': 'rok',
		'options.grouping.name.text.1': 'bez grupowania',
		'options.grouping.name.text.2': 'grupowanie według dni',
		'options.grouping.name.text.3': 'grupowanie według tygodni',
		'options.grouping.name.text.4': 'grupowanie według miesięcy',
		'options.grouping.name.text.5': 'grupowanie według lat',
		'options.grouping.ranking.name.1': 'Tylko dane',
		'options.grouping.ranking.name.2': 'Wykres standardowy',
		'options.grouping.ranking.name.3': 'Wykres procentowy',
		'datepicker.choose.range.info': 'Wybierz początkowy lub końcowy zakres dat',
		'datepicker.choose.range.invalidFormat': 'Data musi być w formacie dd.MM.yyyy (np. 15.12.2025)',
		'today': 'Dzisiaj',
		'days': 'Dni',
		'day': 'Dzień',
		'thousand': 'TYS',
		'million': 'MLN'
	},
	en: {
		'service.worker.update.message': 'A new version of the application is available.',
		'service.worker.update.logoutWarning': 'You will be logged out after refreshing.',
		'service.worker.update.button': 'Refresh',
		'service.worker.update.refreshing': 'Refreshing…',
		'sales.status.generated': 'Generated',
		'sales.status.settle': 'In settlement',
		'sales.status.realized': 'Settled',
		'sales.status.booked': 'Booked',
		'sales.type.domestic': 'Domestic',
		'sales.type.union': 'Union',
		'sales.type.export': 'Export',
		'text.companyType': 'Company Type',
		'text.animators': 'Animators',
		'text.suppliers': 'Suppliers',
		'placeholder.choose': 'Choose',
		'yup.required': 'Required field.',
		'yup.number.required': 'Valid number required.',
		'yup.string.required': 'Valid value required.',
		'yup.string.email': 'Email is invalid.',
		'yup.string.min': 'Min number of characters: ${min}',
		'yup.string.max': 'Max characters: ${max}',
		'yup.number.positive': 'Positive number required.',
		'yup.number.min': 'Min value: ${min}',
		'yup.number.max': 'Max value: ${max}',
		'yup.date.min': 'Date cannot be past.',
		'yup.date.max': 'The date cannot be future.',
		'yup.polandNip': 'Nip is invalid.',
		'yup.polandPhoneNumber': 'Invalid phone number for this country.',
		'yup.polandNrb': 'Bank account number does not meet NRB requirements.',
		'yup.polandPostalCode': 'Invalid format.',
		'empty.formatBankNumber': 'None',
		'empty.formatAddress': 'None',
		'empty.formatAddressCommune': 'None',
		'empty.street': 'st. ',
		'empty.commune': 'Commune:',
		'empty.district.part.1a': ', d',
		'empty.district.part.1b': 'D',
		'empty.district.part.2': 'istrict:',
		'empty.province': 'Province:',
		'empty.country': 'Country:',
		'empty.formatNip': 'None',
		'empty.readonly': 'None',
		'boolean.yes': 'Yes',
		'boolean.no': 'No',
		'options.notificationEmailGroups.name.1': 'User profile',
		'options.notificationEmailGroups.name.2': 'Agreement',
		'options.notificationEmailGroups.name.3': 'Invoices and orders',
		'options.notificationEmailGroups.name.4': 'Marketing',
		'options.notificationEmailGroups.name.5': 'Help',
		'options.notificationPersonGroups.name.1': 'User profile',
		'options.notificationPersonGroups.name.2': 'Agreement',
		'options.notificationPersonGroups.name.3': 'Invoices and orders',
		'options.notificationPersonGroups.name.4': 'Marketing',
		'options.notificationPersonGroups.name.5': 'Help',
		'options.aml.type.1': 'Base',
		'options.aml.type.2': 'Standard',
		'options.aml.type.3': 'Extra',
		'options.aml.type.4': 'Max',
		'options.grouping.name.1': 'no grouping',
		'options.grouping.name.2': 'day',
		'options.grouping.name.3': 'week',
		'options.grouping.name.4': 'month',
		'options.grouping.name.5': 'year',
		'options.grouping.name.text.1': 'no grouping',
		'options.grouping.name.text.2': 'grouping by days',
		'options.grouping.name.text.3': 'grouping by weeks',
		'options.grouping.name.text.4': 'grouping by months',
		'options.grouping.name.text.5': 'grouping by years',
		'options.grouping.ranking.name.1': 'Data only',
		'options.grouping.ranking.name.2': 'Standard Chart',
		'options.grouping.ranking.name.3': 'Precentage Chart',
		'datepicker.choose.range.info': 'Choose start or end date range',
		'datepicker.choose.range.invalidFormat': 'Date must be in format dd.MM.yyyy (e.g., 15.12.2025)',
		'today': 'Today',
		'days': 'Days',
		'day': 'Day',
		'thousand': 'K',
		'million': 'M'
	},
};

export default translatePaths;
